import { CreatePierRequest, PierResponse, PiersApi, UpdatePierRequest } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

export class PierService {
  private readonly httpClient = createApiClient(PiersApi)

  async load(): Promise<PierResponse[]> {
    const { data } = await this.httpClient.getPiers()
    return data.piers
  }

  async create(pier: CreatePierRequest): Promise<string> {
    const { data } = await this.httpClient.createPier(pier)
    return data.id
  }

  async update(pier: UpdatePierRequest): Promise<void> {
    await this.httpClient.updatePier(pier)
  }

  async delete(id: string): Promise<void> {
    await this.httpClient.deletePier({ id })
  }
}

export const pierService = new PierService()
